// Affect installer slim-select setup
document.addEventListener('DOMContentLoaded', () => {
  const searchInputId = 'installer_company_search'
  const searchInput = document.querySelector(`#${searchInputId}`)
  if (!searchInput) return

  // Wait for SlimSelect to be available
  let retryCount = 0
  const maxRetries = 10
  const retryDelay = 200 // ms

  function setupSlimSelect() {
    if (typeof window.SlimSelect === 'undefined') {
      if (retryCount < maxRetries) {
        retryCount++
        console.warn(`SlimSelect not available yet, retrying... (${retryCount}/${maxRetries})`)
        setTimeout(setupSlimSelect, retryDelay)
      } else {
        console.error('SlimSelect not available after multiple retries.')
      }
      return
    }

    const slimSelect = new window.SlimSelect({
      select: searchInput,
      settings: {
        placeholder: '',
        allowDeselect: true,
        searchPlaceholder: 'Rechercher une société...',
        searchText: 'Aucun résultat',
        searchingText: 'Recherche...',
      },
      events: {
        search: (search, currentData) => {
          return new Promise((resolve, reject) => {
            if (search.length < 2) {
              reject('Veuillez entrer au moins 2 caractères')
              return
            }

            const query = `q[role_in][]=installer&q[name_cont]=${encodeURIComponent(search)}`
            const csrfTokenEl = document.querySelector('meta[name="csrf-token"]')
            const csrfToken = csrfTokenEl ? csrfTokenEl.getAttribute('content') : null

            fetch(`/companies.json?${query}`, {
              method: 'GET',
              headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
            })
              .then((response) => response.json())
              .then((res) => {
                const data = res.data || []
                const options = data.map((obj) => ({
                  value: obj.id,
                  text: `${obj.attributes.name} (id: ${obj.id})`,
                }))
                resolve(options)
              })
              .catch((error) => {
                console.error('Error fetching companies:', error)
                reject('Erreur lors de la recherche')
              })
          })
        },
        // Ensure the native select value is updated when a selection is made
        afterChange: (newVal) => {
          // Trigger change event on the native select to ensure form submission works
          searchInput.dispatchEvent(new Event('change', { bubbles: true }))
        },
      },
    })
  }

  // Initialisation
  setupSlimSelect()
})

